export * from './authentication';
export * from './template';
export * from './setupModalUtils';

export const DESIGN_HUDDLE_DOMAIN = 'authorify.designhuddle.com';
